/** A secret link: the token stays in the fragment, never sent to a server or kept in logs (spec §9.3). */
export const shareUrl = (origin: string, token: string): string => `${origin}/s#${token}`;

/** `url` opening on page `pageId` (P14): `?page=` before any fragment (a secret link keeps its token there). */
export function withPage(url: string, pageId: string | null): string {
  if (pageId === null) return url;
  const u = new URL(url);
  u.searchParams.set('page', pageId);
  return u.toString();
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
